import React from "react";

const FetchError = () => {
  return (
    <>
      {/* <Icon
        icon="bx:bxs-error-circle"
        color="#c7222a"
        height="3rem"
        width="3rem"
      /> */}
      {/* <p>{languageContent.error_page.sorry}</p> */}
      <p>Not able to fetch data</p>
    </>
  );
};

export default FetchError;
